(function (angular) {
    'use strict';

    angular.module('ui.order.newOrder.calendarService', [])

        .service('newOrderCalendarService', function ($q, calendarService, centresRepository, customersRepository) {

            angular.extend(this, {
                datePickerOptions: datePickerOptions,
                areDatesDifferent: areDatesDifferent,
                areDatesEqual: areDatesEqual,
                twoDatesDifferent: twoDatesDifferent,
                twoDatesEqual: twoDatesEqual,
                maxDate: maxDate,
                destroy: destroy,
                init: init
            });

            var _this = this;
            var _publicHolidays = [];

            return _this;

            function datePickerOptions(customerId) {
                return countryCode(customerId)
                    .then(initPublicHolidays)
                    .then(datePickerOptionsBase);
            }

            function datePickerOptionsBase() {
                return {
                    disableDates: isDateNotAvailable
                };
            }

            function isDateNotAvailable(date) {
                if (!date) return true;
                if (isDayInPast(date)) return true;
                if (isWeekendDay(date)) return true;
                if (isPublicHoliday(date)) return true;

                return false;
            }

            function isWeekendDay(date) {
                return date.getDay() === 0 || date.getDay() === 6;
            }

            function isDayInPast(date) {
                var currentDate = new Date();
                return dateCode(date) < dateCode(currentDate);
            }

            function dateCode(date) {
                return date.getFullYear() * 10000 + date.getMonth() * 100 + date.getDate();
            }

            function isPublicHoliday(date) {
                return _.any(_publicHolidays, function (holiday) {
                    return twoDatesEqual(holiday, date);
                });
            }

            function twoDatesEqual(dateOne, dateTwo) {
                if (!dateOne && !dateTwo) return true;
                if (!dateOne) return false;
                if (!dateTwo) return false;

                return dateCode(dateOne) === dateCode(dateTwo);
            }

            function twoDatesDifferent(dateOne, dateTwo) {
                return !twoDatesEqual(dateOne, dateTwo);
            }

            function areDatesEqual(dates) {
                if (!dates) return true;
                if (dates.length < 2) return true;

                return _.all(dates, function (date) {
                    return twoDatesEqual(dates[0], date)
                });
            }

            function areDatesDifferent(dates) {
                return !areDatesEqual(dates);
            }

            function maxDate(dates) {
                return _.max(dates, function (date) {
                    return dateCode(date);
                });
            }

            function initPublicHolidays(countryCode) {
                _publicHolidays = [];
                if (countryCode) {
                    return calendarService
                        .getActualPublicHolidays(countryCode)
                        .then(function (holidays) {
                            _publicHolidays = holidays || [];
                        });
                }
            }

            function countryCode(customerId) {
                if (!customerId) return $q.when("");

                return customersRepository
                    .getCustomer(customerId)
                    .then(countryCodeFromCustomer);
            }

            function countryCodeFromCustomer(customerModel) {
                return centresRepository
                    .getCentre(customerModel.$model.centreId)
                    .then(countryCodeFromCentre);
            }

            function countryCodeFromCentre(centreModel) {
                var countryCode = centreModel.$model.address.$model.country || "";
                if (countryCode) {
                    countryCode = countryCode.slice(0, 2);
                }

                return countryCode;
            }

            function init() {
                return $q.all([]);
            }

            function destroy() {
            }
        });
})(window.angular);
